import { MfeComponent } from '@/common/MicroFrontEnds';
import useLoadSoftPullMfe from '@/common/Modals/SoftPullMfeModal/useLoadSoftPullMfe';
import useToggleModal from '@/common/Modals/SoftPullMfeModal/useToggleModal';
import { SOFTPULL_MODULE } from '~/constants/common/MfeModules';
import { useIsLoggedIn } from '~/context/common/UserContext';
import useMfeMountGate from '~/hooks/common/mfe/useMfeMountGate';
import useEventListeners from './useEventListeners';

const dummyFn = () => {};

type OwnProps = {
  consumer: 'Drive' | 'FLP' | 'Home' | 'Search' | 'VDP';
  isAddCoApplicantModalOpen: boolean;
  isEditCoApplicantModalOpen?: boolean;
  isSoftPullModalOpen: boolean;
  landingHeading?: string;
  landingSubheading?: string;
  showLogo?: boolean;
  setIsAddCoApplicantModalOpen: (isOpen: boolean) => void;
  setIsEditCoApplicantModalOpen?: (isOpen: boolean) => void;
  setIsSoftPullModalOpen: (isOpen: boolean) => void;
  setShouldRefreshSoftPull: () => void;
};

export default function SoftPullMfeModal({
  consumer,
  isAddCoApplicantModalOpen,
  isEditCoApplicantModalOpen = false,
  isSoftPullModalOpen,
  landingHeading,
  landingSubheading,
  showLogo,
  setIsAddCoApplicantModalOpen,
  setIsEditCoApplicantModalOpen = dummyFn,
  setIsSoftPullModalOpen,
  setShouldRefreshSoftPull
}: OwnProps) {
  const isLoggedIn = useIsLoggedIn();
  const canMount = useMfeMountGate(SOFTPULL_MODULE);

  useLoadSoftPullMfe();
  useToggleModal({
    canMount,
    isAddCoApplicantModalOpen,
    isEditCoApplicantModalOpen,
    isSoftPullModalOpen,
    landingHeading,
    landingSubheading,
    showLogo,
    setAddCoApplicantModalOpen: setIsAddCoApplicantModalOpen,
    setEditCoApplicantModalOpen: setIsEditCoApplicantModalOpen,
    setSoftPullModalOpen: setIsSoftPullModalOpen
  });

  useEventListeners(setShouldRefreshSoftPull);

  // Wait for the previous instance's teardown before rendering — see useMfeMountGate.
  if (!canMount) return null;

  return (
    <MfeComponent<{
      externalIsLoggedIn: boolean;
      softPullSource: string;
    }>
      component="default"
      module="SoftPullModule"
      softPullSource={consumer}
      externalIsLoggedIn={isLoggedIn}
    />
  );
}
